import constants from './constants';

export default (subscriptionType) => {
    return subscriptionType === constants.SUBSSCRIPTION_TYPE.INVALID_SUBSCRIPTION_TYPE.none.value;
};
